import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const patientProfileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientProfile: builder.query<
      any,
      { patientId: number; preferredLanguage: string }
    >({
      query: ({ patientId, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/${patientId}/patient-profile`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientProfileQuery } = patientProfileApi;
export default patientProfileApi;
